import React, { useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { TrackQRPrint } from '../../utilities/insights';

import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import DashboardSticker from './components/DashboardSticker';

import './QRcode.css';
import { useSelector, useDispatch } from 'react-redux';
import { getDashboard } from '../../redux/thunks/dashboard';
import { Button } from '@material-ui/core';

const DashboardQRCode = ({ match }) => {
    const { dashboardId, siteId } = match.params;
    const componentRef = useRef();
    const userName = useSelector((state) => state.user.userName);
    const email = useSelector((state) => state.user.email);
    const selectedDashboard = useSelector((state) => state.dashboard.selectedDashboard);
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        if (!selectedDashboard.name) {
            dispatch(getDashboard(siteId, dashboardId));
        }
    }, [selectedDashboard, siteId, dashboardId, dispatch]);

    const handlePrint = () => {
        // APP INSIGHTS: Track Print Submission
        TrackQRPrint(siteId, dashboardId, userName, email);
        reactToPrint();
    };

    const reactToPrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (
        <div className='page-container'>
            <div className='text-center'>
                <h2>Here is the new tag for your Qdash Dashboard!</h2>
                <DashboardSticker siteId={siteId} dashboardId={dashboardId} name={selectedDashboard?.name} ref={componentRef} />
                <div className='page-actions'>
                    <Button color='default' size='large' variant='contained' startIcon={<ArrowBackIcon fontSize='small' />} style={{ margin: '4px' }} onClick={() => history.push(`/site/${siteId}/dashboard/${dashboardId}/`)}>
                        Back to Dashboard
                    </Button>
                    <Button color='primary' size='large' variant='contained' onClick={handlePrint} style={{ margin: '4px' }}>
                        Print
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default DashboardQRCode;
